import {TENANT_BASE_URL} from "../../../common/Config/UrlHelper";
import DatatableHelperMixin from "../../../common/Mixin/Global/DatatableHelperMixin";
import HelperMixin from "../../../common/Mixin/Global/HelperMixin";
import {formatDateToLocal} from "../../../common/Helper/Support/DateTimeHelper";

export default {
    mixins: [HelperMixin, DatatableHelperMixin],
    data() {
        return {
            options: {
                name: this.$t('advance_payment'),
                url: `${TENANT_BASE_URL}app/advance-payments`,
                showHeader: true,
                showCount: true,
                tableShadow: false,
                columns: [
                    {
                        title: this.$t('actions'),
                        type: 'action',
                        key: 'id',
                        isVisible: true
                    },
                    {
                        title: this.$t('employee'),
                        type: 'custom-html',
                        key: 'employee',
                        modifier: value => value ? value.full_name : '--'
                    },
                    {
                        title: this.$t('transaction'),
                        type: 'custom-html',
                        key: 'transaction_id',
                        modifier: value => value || '--'
                    },
                    {
                        title: this.$t('status'),
                        type: 'custom-html',
                        key: 'status',
                        modifier: value => value ? this.$t(value) : '--'
                    },
                    {
                        title: this.$t('remark'),
                        type: 'custom-html',
                        key: 'remark',
                        modifier: value => value || '--'
                    },
                    {
                        title: this.$t('created_at'),
                        type: 'custom-html',
                        key: 'created_at',
                        modifier: value => value ? formatDateToLocal(value) : '--'
                    },
                ],
                actions: [
                    {
                        title: this.$t('edit'),
                        icon: 'edit',
                        type: 'modal',
                        name: 'edit',
                        modifier: () => this.$can('update_advance_payments')
                    },
                    {
                        title: this.$t('delete'),
                        icon: 'trash-2',
                        type: 'modal',
                        component: 'app-confirmation-modal',
                        modalId: 'app-confirmation-modal',
                        url: `${TENANT_BASE_URL}app/advance-payments/`,
                        name: 'delete',
                        modifier: () => this.$can('delete_advance_payments')
                    }
                ],
                showAction: true,
                actionType: 'dropdown',
                orderBy: 'desc',
                paginationType: "pagination",
                rowLimit: 10,
            }
        }
    },
}
